// extracted by mini-css-extract-plugin
export default {"graph":"Statistics_graph__ZSRNz"};